import { useEffect, useState } from "react";
import { createCarBrand, getOrderTypes} from "../services/ordertype.service";
import OrderTypeHeader from "../components/ordertype/BrandHeader";
import OrderTypeTable from "../components/ordertype/BrandTable";
import OrderTypeCreateModal from "../components/ordertype/BrandCreateModal";
import OrderTypeEditModal from "../components/ordertype/BrandEditModal";
import OrderTypeDeleteModal from "../components/ordertype/BrandDeleteModal";
import { useToast } from "../context/ToastContext";


export default function OrderTypes() {
  const [ordertypes, setOrdertypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [selected, setSelected] = useState(null);
  const [editTarget, setEditTarget] = useState(null); 
  const [deleteTarget, setDeleteTarget] = useState(null);   
  const { showToast } = useToast();         


  async function loadOrdertypes() {
    try {
      const data = await getOrderTypes();
      setOrdertypes(data);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadOrdertypes();
  }, []);

  function handleView(ordertype) {
    setSelected(ordertype);
  }


  const filtered = ordertypes.filter((c) => {
    const q = search.toLowerCase();
    return (c.name || "").toLowerCase().includes(q);
  });

  if (loading) return <p>Chargement…</p>;

  return (
    <div className="page">
      <OrderTypeHeader
        total={filtered.length}
        search={search}
        onSearch={setSearch}
        onAdd={() => setOpenCreate(true)}
        onEdit={(ordertype) => setEditTarget(ordertype)}
      />

      <OrderTypeTable 
      ordertypes={filtered} 
      onView={handleView} 
      onEdit={(ordertype) => setEditTarget(ordertype)}
      onDelete={(ordertype) => setDeleteTarget(ordertype)}
      />

      <OrderTypeCreateModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        // onSubmit={handleCreate}
      />

      <OrderTypeEditModal
        open={!!editTarget}
        ordertype={editTarget}
        onClose={() => setEditTarget(null)}
        // onSubmit={handleEditSubmit}
      />

      <OrderTypeDeleteModal
        ordertype={deleteTarget}
        onClose={() => setDeleteTarget(null)}
        // onConfirm={handleDelete}
      />
    </div>
  );
}
